var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 22.03 18.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#008fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,0H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H13.47a5.57,5.57,0,0,1-.17-1.36,4.49,4.49,0,0,1,0-.64H2V8H18V9.13a4.4,4.4,0,0,1,.89-.08A5.8,5.8,0,0,1,20,9.16V2A2,2,0,0,0,18,0Zm0,4H2V2H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.74,18.92q-4,0-4-4.29a4.56,4.56,0,0,1,1-3.15,3.63,3.63,0,0,1,2.84-1.11,3.69,3.69,0,0,1,1.46.26,2.09,2.09,0,0,1,1,.76l-.87,1.14a1.71,1.71,0,0,0-.67-.51,2.13,2.13,0,0,0-.88-.18,2,2,0,0,0-1.62.71,3.06,3.06,0,0,0-.6,2c0,1.92.85,2.87,2.55,2.87a4.14,4.14,0,0,0,1.67-.35l.27,1.43A5.73,5.73,0,0,1,19.74,18.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.f9dd5d0771abe886edbab4911ec39904.svg";
export { ForwardRef as ReactComponent };